import { useState } from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter, CardHeader } from '../ui/Card.jsx';

const Form = ({ ...props }) => {
    const { heading, inputs, button, feedback, formData, fn } = props;
    const [data, setData] = useState(() => {
        const initial = {};
        inputs.forEach((input) => {
            if ('checkbox' === input.type) {
                initial[input.name] = [];
            } else {
                initial[input.name] = '';
            }
        });
        return initial;
    });

    const handleChange = (e) => {
        const { type, name, value } = e.target;

        if ('checkbox' === type) {
            handleCheckbox(name, value);
        }
    };
    const handleCheckbox = (name, value) => {
        const prevValues = formData && formData[name] ? formData[name] : [];
        const newValues = prevValues.includes(value) ? prevValues.filter((item) => item !== value) : [...prevValues, value];

        fn.handleFormChange({ ...formData, [name]: newValues });
    };

    const isChecked = (name, value) => {
        return !!(formData && formData[name] && formData[name].includes(value));
    };

    // useEffect(()=> {
    //     fn.handleFormChange({[inputs[0].name]: []})
    //
    // },[])

    console.log(formData);
    return (
        <div className="component-form">
            <h1>{heading}</h1>

            <Card>
                <CardHeader>
                    <h2 className="card-title">{inputs[0].label}</h2>
                </CardHeader>
                <CardBody>
                    <div className="row justify-center">
                        <div className="col lg:w-10/12 xl:w-8/12">
                            {inputs.map((input, index) => (
                                <div key={index} className="form-group">
                                    <div className="form-checkbox-options">
                                        {input.options.map((option, optIndex) => (
                                            <div key={optIndex} className="form-checkbox">
                                                <input
                                                    className="input-control"
                                                    type="checkbox"
                                                    id={option.id}
                                                    name={input.name}
                                                    checked={isChecked(input.name, option.id.toString())}
                                                    value={option.id}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                                <button
                                                    className="input-checkbox"
                                                    onClick={() => handleCheckbox(input.name, option.id.toString())}
                                                ></button>
                                                <label className="input-label" htmlFor={option.id}>
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}

                            {feedback && <div className="feedback mt-10">{feedback.message}</div>}
                        </div>
                    </div>

                    {feedback && <div className="feedback mt-10">{feedback.message}</div>}
                </CardBody>
                <CardFooter>{button && <Button {...button} onClick={() => fn.handleAction(button.action)} />}</CardFooter>
            </Card>
        </div>
    );
};

export default Form;
